export function ErrorCodeTranslationKey(message: string) {
  return `ERROR_LINK_${message}`;
}

export function ErrorCodeButtonText(message: string) {
  switch (message) {
    // Parcel Details
    case 'ITEM-WEIGHT':
      return 'Add Parcel Weight';
    case 'ITEM-WEIGHT-CHANGE':
      return 'Change Parcel Weight';
    // -REVIEW exists separately because the -CHANGE keys already have stored translations, which outrank
    // anything written here.
    case 'ITEM-WEIGHT-REVIEW':
      return 'Check Parcel Weight';
    case 'ITEM-VALUE':
      return 'Add Parcel Value';
    case 'ITEM-VALUE-REVIEW':
      return 'Check Parcel Value';
    case 'ITEM-DESCRIPTION':
      return 'Add Parcel Description';
    case 'ITEM-DIMENSIONS':
      return 'Add Parcel Dimensions';
    case 'ITEM-DIMENSIONS-CHANGE':
      return 'Change Parcel Dimensions';
    case 'ITEM-DIMENSIONS-REVIEW':
      return 'Check Parcel Dimensions';
    case 'ITEM-PARCEL-EMPTY':
      return 'Add Parcel Contents';
    case 'ITEM-PROHIB-INVALID':
      return 'View Parcel Details';

    // Service
    case 'SERVICE-NO-PICKUP-SHOP-AVAILABLE':
      return `Change Service`;
    case 'SERVICE-MULTIPARCEL-UNSUPPORTED':
      return `Edit Shipment Details`;
    case 'SERVICE-DDU-UNSUPPORTED':
      return `View Duty Options`;
    case 'SERVICE-MISSING':
      return 'Choose Service';
    case 'SERVICE-UNAVAILABLE':
    case 'SERVICE-CHANGE':
    case 'SERVICE-UNSUPPORTED-MARKETPLACE-TEMU':
    case 'SERVICE-UNSUPPORTED-MARKETPLACE-TIKTOK':
    case 'SERVICE-UNSUPPORTED-MARKETPLACE-SHEIN':
      return 'Change Service';
    case 'SERVICE-COLLECTION-DATE':
      return 'Change Collection Date';

    // Extras
    case 'EXTRAS-UNAVAILABLE':
      return 'Edit Extras';

    // Recipient
    case 'ADDRESS-RECIPIENT-PHONE-REQUIRED':
    case 'ADDRESS-RECIPIENT-EMAIL-REQUIRED':
    case 'ADDRESS-RECIPIENT-NAME-REQUIRED':
    case 'ADDRESS-RECIPIENT-ADDRESSLINE1-REQUIRED':
    case 'ADDRESS-RECIPIENT-ADDRESSLINE2-REQUIRED':
    case 'ADDRESS-RECIPIENT-TOWN-REQUIRED':
    case 'ADDRESS-RECIPIENT-POSTCODE-REQUIRED':
    case 'ADDRESS-RECIPIENT-COUNTY-REQUIRED':
      return 'Add Recipient Details';

    case 'ADDRESS-RECIPIENT-COUNTY-INVALID-OPTION':
      return 'Fix County Details';

    case 'ADDRESS-RECIPIENT-SAMEEMAIL-SHOP-DELIVERY':
    case 'ADDRESS-RECIPIENT-SAMEEMAIL-LOCKER-DELIVERY':
      return 'Add Recipient Email';

    // ADDRESS-RECIPIENT-CHANGE is a link only, never a headline - raised by QuoteErrorResolutions.
    case 'ADDRESS-RECIPIENT-POSTCODE-FORMAT':
    case 'ADDRESS-RECIPIENT-PHONE-FORMAT':
    case 'ADDRESS-RECIPIENT-PHONE-MIN-LENGTH':
    case 'ADDRESS-RECIPIENT-PHONE-MAX-LENGTH':
    case 'ADDRESS-RECIPIENT-EMAIL-FORMAT':
    case 'ADDRESS-RECIPIENT-SAMEPOSTCODE':
    case 'ADDRESS-RECIPIENT-CHANGE':
      return 'View Recipient Details';

    // Sender
    case 'ADDRESS-SENDER-PHONE-REQUIRED':
    case 'ADDRESS-SENDER-EMAIL-REQUIRED':
    case 'ADDRESS-SENDER-NAME-REQUIRED':
    case 'ADDRESS-SENDER-ADDRESSLINE1-REQUIRED':
    case 'ADDRESS-SENDER-ADDRESSLINE2-REQUIRED':
    case 'ADDRESS-SENDER-TOWN-REQUIRED':
    case 'ADDRESS-SENDER-POSTCODE-REQUIRED':
    case 'ADDRESS-SENDER-COUNTY-REQUIRED':
      return 'Add Sender Details';

    case 'ADDRESS-SENDER-COUNTY-INVALID-OPTION':
      return 'Fix County Details';

    case 'ADDRESS-SENDER-POSTCODE-FORMAT':
    case 'ADDRESS-SENDER-PHONE-FORMAT':
    case 'ADDRESS-SENDER-PHONE-MIN-LENGTH':
    case 'ADDRESS-SENDER-PHONE-MAX-LENGTH':
    case 'ADDRESS-SENDER-EMAIL-FORMAT':
    case 'ADDRESS-SENDER-CHANGE':
      return 'View Sender Details';

    // Customs
    case 'CUSTOMS-RECIPIENT-TAXID-FORMAT':
    case 'CUSTOMS-SENDER-TAXID-FORMAT':
      return 'Edit TAX Details';

    case 'CUSTOMS-RECIPIENT-UKIMS-FORMAT':
    case 'CUSTOMS-SENDER-UKIMS-FORMAT':
      return 'Edit UKIMS Details';

    case 'CUSTOMS-SENDER-EORINUMBER-REQUIRED':
    case 'CUSTOMS-RECIPIENT-EORINUMBER-REQUIRED':
      return 'Add EORI Number';

    case 'CUSTOMS-SENDER-VATNUMBER-OR-TAXID-REQUIRED':
      return 'Add Tax Details';

    case 'CUSTOMS-RECIPIENT-VATNUMBER-REQUIRED':
    case 'CUSTOMS-RECIPIENT-VATNUMBER-CONDITIONALLY-REQUIRED':
    case 'CUSTOMS-SENDER-VATNUMBER-REQUIRED':
    case 'CUSTOMS-SENDER-VATNUMBER-CONDITIONALLY-REQUIRED':
      return `Add {{taxName}} Number`;

    case 'CUSTOMS-SENDER-VATNUMBER-FORMAT':
      return `Fix {{taxName}} Number`;

    case 'CUSTOMS-SENDER-TAXID-REQUIRED':
    case 'CUSTOMS-RECIPIENT-TAXID-REQUIRED':
    case 'CUSTOMS-RECIPIENT-TAXID-CONDITIONALLY-REQUIRED':
      return 'Add TAX Number';

    case 'CUSTOMS-SENDER-UKIMS-REQUIRED':
    case 'CUSTOMS-RECIPIENT-UKIMS-REQUIRED':
      return 'Add UKIMS Number';

    case 'CUSTOMS-RECIPIENT-VATSTATUS-REQUIRED':
    case 'CUSTOMS-SENDER-VATSTATUS-REQUIRED':
      return 'Add Tax Status';

    case 'PRODUCT-TARIFFCODE-REQUIRED':
      return 'Add Tariff Code';

    case 'PRODUCT-TARIFFCODE-TOO-SHORT':
      return 'View Current Code';

    case 'ITEM-EXPORTREASON-REQUIRED':
      return 'Add Export Details';

    case 'ITEM-IOSSNUMBER-REQUIRED':
      return 'Add IOSS Number';

    case 'ITEM-IOSSNUMBER-FORMAT':
      return 'Fix IOSS Number';

    case 'PRODUCT-COUNTRYOFMANUFACTURE-REQUIRED':
      return 'Add Country of Manufacture';
  }
  return message;
}
